import { useEffect } from "react";
import { CTAButton } from "../components/ui-regera/CTAButton";
import { Overline } from "../components/ui-regera/Section";
import { Frame, Head } from "../components/spec/Frame";
import { ABOUT } from "../data/content";

// Two frames (customer review p13): "Who we are" + "Our point of view" belong together, as do
// "How we work" + "Leadership". All copy is unchanged; only the composition is.
export default function About() {
  useEffect(() => {
    document.title = "About — REGERA";
  }, []);
  return (
    <div data-testid="about-page">
      <Frame id="about-intro" first>
        <Head as="h1" size="lg" fit {...ABOUT.who} />
        <div className="rg-gap mt-10 pt-8 border-t border-white/10 grid lg:grid-cols-12 gap-6 lg:gap-12">
          <div className="lg:col-span-6">
            <Overline>{ABOUT.pov.overline}</Overline>
            <h2 className="mt-5 font-display font-black text-white tracking-tight leading-[1.08] text-3xl sm:text-4xl rg-fs-sub">
              {ABOUT.pov.title}
            </h2>
          </div>
          <p className="lg:col-span-6 lg:pt-10 text-white/75 text-base lg:text-lg leading-relaxed rg-fs-lead">{ABOUT.pov.body}</p>
        </div>
      </Frame>
      <Frame id="about-how">
        <Head overline={ABOUT.how.overline} title={ABOUT.how.title} fit />
        <div className="rg-gap mt-10 grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
          {ABOUT.how.ideas.map((x, i) => (
            <div key={x.title} data-pg-item className="bg-[#0a0a0a] p-6 rg-pad">
              <span className="font-display text-2xl font-black text-[#e60000]">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-4 font-display text-lg font-bold text-white rg-fs-h3">{x.title}</h3>
              <p className="mt-2 text-white/70 leading-relaxed rg-fs-text">{x.text}</p>
            </div>
          ))}
        </div>
        <div className="rg-gap mt-12 grid lg:grid-cols-12 gap-6 lg:gap-12 lg:items-start">
          <div className="lg:col-span-6">
            <Overline>{ABOUT.leadership.overline}</Overline>
            <h2 className="mt-5 font-display font-black text-white tracking-tight leading-[1.08] text-3xl sm:text-4xl rg-fs-sub">
              {ABOUT.leadership.title}
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="text-white/75 text-base lg:text-lg leading-relaxed rg-fs-lead">{ABOUT.leadership.body}</p>
            <CTAButton to="/contact#enquiry" testId="about-engage-cta" className="mt-6">Engage REGERA</CTAButton>
          </div>
        </div>
      </Frame>
    </div>
  );
}
